import { openExplorerInNewTab } from "../../utils/explorerHelper.ts";
import { useQuery } from "@tanstack/react-query";
import {
  getEscrowTransactions,
  type Transaction,
} from "../../repository/EscrowRepository.ts";
import { formatEventName } from "../../utils/formatEventName.ts";
import {ExternalLinkIcon} from "lucide-react";

const LoadingTransactionsTable = () => {
  return (
    <tbody>
      {Array.from({ length: 2 }, (_, index) => (
        <tr key={index}>
          <td>
            <div className="skeleton h-10 w-full" />
          </td>
          <td className="w-full">
            <div className="skeleton h-10 w-full" />
          </td>
          <td className="w-full">
            <div className="skeleton h-10 w-full" />
          </td>
        </tr>
      ))}
    </tbody>
  );
};

const TransactionRow = ({
  transaction,
  sellerAddress,
  sellerNickname,
  buyerNickname,
}: {
  transaction: Transaction;
  sellerAddress: string;
  sellerNickname: string | null;
  buyerNickname: string | null;
}) => {
  const party = (transaction.transaction_payload as { party?: string })?.party;

  return (
    <tr>
      <td className={"w-full"}>
        {formatEventName(transaction.transaction_name)}
      </td>
      <td>
        {party != undefined
          ? party.toLowerCase() == sellerAddress.toLowerCase()
            ? "Seller" + (sellerNickname ? ` (${sellerNickname})` : "")
            : "Buyer" + (buyerNickname ? ` (${buyerNickname})` : "")
          : "Contract"}
      </td>
      <td>
        {new Date(parseInt(transaction.timestamp) * 1000).toLocaleString()}
      </td>
      <td>
        <button
          className="btn btn-sm"
          onClick={() => openExplorerInNewTab(transaction.tx)}
        >
          <ExternalLinkIcon />
        </button>
      </td>
    </tr>
  );
};

const TransactionsTable = ({
  address,
  sellerAddress,
  buyerNickname,
  sellerNickname,
}: {
  address: string;
  sellerAddress: string;
  buyerNickname: string | null;
  sellerNickname: string | null;
}) => {
  const {
    data: transactions,
    isLoading,
    isSuccess,
  } = useQuery({
    queryKey: ["transactions"],
    queryFn: () => getEscrowTransactions(address),
    refetchInterval: 5000,
  });

  return (
    <div className="overflow-x-auto">
      <table className="table">
        <thead>
          <tr>
            <th>Action</th>
            <th>Sender</th>
            <th>Execution date</th>
            <th>TX ID</th>
          </tr>
        </thead>
        {isLoading && <LoadingTransactionsTable />}
        {isSuccess && (
          <tbody>
            {transactions.map((transaction, index) => (
              <TransactionRow
                key={index}
                transaction={transaction}
                sellerAddress={sellerAddress}
                sellerNickname={sellerNickname}
                buyerNickname={buyerNickname}
              />
            ))}
          </tbody>
        )}
      </table>
    </div>
  );
};

export default TransactionsTable;
